import { StyleSheet, Dimensions } from 'react-native';

const { width: screenWidth } = Dimensions.get('window');

export default StyleSheet.create({
  leftBackgroundColor: theme => ({
    backgroundColor: theme.colors.tintColor,
    height: 12,
    width: screenWidth / 2 - 10,
    position: 'absolute',
    left: 0,
  }),
  rightBackgroundColor: theme => ({
    backgroundColor: theme.colors.tintColor,
    height: 12,
    width: screenWidth / 2 - 10,
    position: 'absolute',
    right: 0,
  }),
  subTrayItemViewContainer: (isExpandedTrayEnabled, index) => ({
    flex: isExpandedTrayEnabled ? 1 : 0,
    height: isExpandedTrayEnabled ? '100%' : 'auto',
    marginLeft: !isExpandedTrayEnabled && index === 0 ? 0 : 8,
    marginRight: 8,
  }),
});
